import every from 'lodash/every';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { getStoreKey } from '../redux/utils/store';

/**
 * Retrieves the times for the given dates.
 * If data is not available for **any** of the dates, then `null` is returned
 * @param {object} cachedAvailability - the availability stored in redux
 * @param {string} providerLocationId
 * @param {Array<string>} dates
 */
export function getAvailability({
    cachedAvailability,
    dates,
    providerLocationId,
    variables,
}) {
    const storeKey = getStoreKey(providerLocationId, variables);
    if (!cachedAvailability[storeKey] || !dates || !dates.length) return null;

    const { canQueryAvailability, times: allCachedTimes } =
        cachedAvailability[storeKey];

    if (canQueryAvailability === false)
        return { times: [], nextAvailability: null };

    if (!dates.every((date) => allCachedTimes[date])) return null;

    const times = dates.map((date) => allCachedTimes[date]);
    const nextAvailability = times[0].nextAvailability;

    return {
        nextAvailability,
        times,
    };
}

export function getNextAvailability({
    cachedAvailability,
    date,
    providerLocationId,
    variables,
}) {
    return get(
        cachedAvailability,
        `[${getStoreKey(
            providerLocationId,
            variables
        )}].times[${date}].nextAvailability`,
        null
    );
}

export function getAvailabilityTypeDisplayed(times) {
    const NO_AVAILABILITY = 'none';
    const FUTURE_AVAILABILITY = 'future';
    const IMMEDIATE_AVAILABILITY = 'immediate';

    const noTimeslotDisplayed = every(times, (time) =>
        isEmpty(time?.timeslots)
    );
    if (!noTimeslotDisplayed) {
        return IMMEDIATE_AVAILABILITY;
    } else {
        const firstAvailability =
            times?.length > 0 ? times[0].nextAvailability?.startTime : null;
        return firstAvailability ? FUTURE_AVAILABILITY : NO_AVAILABILITY;
    }
}
